export default __webpack_public_path__ + "static/media/20.7d60bd75.webp";